import React from 'react'
import {Form, Input, Radio, DatePicker} from 'antd'
import moment from 'lib/localizedMoment'
import OrderNavigation from 'components/shared/OrderNavigation'

const ResourcePreferencesForm = ({productSelection, handleSubmit, goToPreviousStep}) => {
  const [form] = Form.useForm()
  const minPreferredResourceDate = moment().add(1, 'days').startOf('day')

  return (
    <Form form={form} layout="vertical" initialValues={productSelection} onFinish={handleSubmit}>
      <Form.Item name="preferredPhotographer" colon={false} label="Ønsket fotograf">
        <Input />
      </Form.Item>

      <Form.Item name="preferredStylist" colon={false} label="Ønsket interiørveileder">
        <Input />
      </Form.Item>

      <Form.Item name="preferredResourceDate" colon={false} label="Ønsket dato">
        <DatePicker
          showToday={false}
          format="DD.MM.YYYY"
          disabledDate={(date) => date < minPreferredResourceDate}
        />
      </Form.Item>

      <h4>Prioritet</h4>
      <Form.Item name="preferredResourcePriority">
        <Radio.Group>
          <Radio value="photographer">Ønsket fotograf</Radio>
          <Radio value="stylist">Ønsket interiørveileder</Radio>
          <Radio value="date">Ønsket dato</Radio>
        </Radio.Group>
      </Form.Item>

      <OrderNavigation
        onBack={goToPreviousStep}
        nextButtonProps={{htmlType: 'submit'}}
      />
    </Form>
  )
}

const ResourcePreferences = ({productSelection, productSelectionReducer, goToNextStep, goToPreviousStep}) => {
  const handleSubmit = (preferences) => {
    productSelectionReducer({type: 'setResourcePreference', preferences})
    goToNextStep()
  }

  return (
    <ResourcePreferencesForm
      productSelection={productSelection}
      handleSubmit={handleSubmit}
      goToPreviousStep={goToPreviousStep}
    />
  )
}

export default ResourcePreferences
